import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetSweetShopArticleCategoriesApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            image: z.object({
                url: z.string(),
            }).optional().nullable(),
        }),
    ),
});

type GetSweetShopArticleCategoriesApiResponse
    = ApiResponse<z.infer<typeof GetSweetShopArticleCategoriesApiResponseSchema>>
    | BaseError;

type GetSweetShopArticleCategoriesActionRequest = undefined

export const getSweetShopArticleCategories = createAsyncThunk<
    GetSweetShopArticleCategoriesApiResponse,
    GetSweetShopArticleCategoriesActionRequest
>(
    'SweetShopPageActionsGetSweetShopArticleCategories',
    async () => apiInstance.get(
        '/sweet-shop-article-categories',
        {
            'fields[0]': 'name',
            'fields[1]': 'description',
            'populate[image][fields][0]': 'url',
        },
        GetSweetShopArticleCategoriesApiResponseSchema,
    ),
);
